import { IconOptions } from '../IconNew'
import { notificationType } from './NotificationType'

export const notificationPosition = {
  top: 'top',
  bottom: 'bottom',
  center: 'center',
}

export const TimeOut = {
  never: -1,
  now: 1,
  oneSeconds: 1000,
  threeSeconds: 3000,
  fiveSeconds: 5000,
  sixSeconds: 6000,
  tenSeconds: 10000,
  fifteenSeconds: 15000,
  thirtySeconds: 30000,
}

export type NotificationTypesOptions = keyof typeof notificationType
export const NotificationTypesOptionArray = Object.keys(notificationType)

export type NotificationPositionOptions = keyof typeof notificationPosition
export const NotificationPositionOptionArray = Object.keys(notificationPosition)

export interface NotificationProps {
  ID?: string
  message: string
  type?: keyof typeof notificationType | Array<keyof typeof notificationType>
  show?: boolean
  actionTitle?: string
  onActionPress?: () => void
  position?: keyof typeof notificationPosition | Array<keyof typeof notificationPosition>
  onDismiss?: () => void
  timeOut?: keyof typeof TimeOut | number
  icon?: IconOptions
}
